import type { ButtonHTMLAttributes } from 'react';
import { Icon, type IconName } from './Icon';
import { cx } from './classNames';
import styles from './IconButton.module.css';

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'aria-label' | 'children'> {
  icon: IconName;
  iconDirectional?: boolean;
  variant?: 'round' | 'ghost';
  'aria-label': string;
}

export function IconButton({
  icon,
  iconDirectional = false,
  variant = 'ghost',
  className,
  type = 'button',
  'aria-label': ariaLabel,
  ...buttonProps
}: IconButtonProps) {
  return (
    <button
      {...buttonProps}
      type={type}
      className={cx(styles.button, styles[variant], className)}
      aria-label={ariaLabel}
    >
      <Icon name={icon} className={styles.icon} size={22} directional={iconDirectional} />
    </button>
  );
}
